export default "__VITE_ASSET__CrYPHDJS__"